import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import PreviewCanvas from '@/common/components/PreviewCanvas/PreviewCanvas'

import { widgetPreviewViews } from '../constants'
import SectionIntro from '../SectionIntro/SectionIntro'
import WidgetPreview from '../WidgetPreview/WidgetPreview'
import * as Styles from './styles'

const PreviewBlock = ({ appearance }) => {
  const { t } = useTranslation()

  return (
    <Styles.Block>
      <SectionIntro
        title={t('Vista previa')}
        description={t('Comprueba cómo se ve y funciona el widget y el popup de Return Protection.')}
      >
        <Alert type="info">{t('Haz clic en el enlace "Saber más" para abrir el popup.')}</Alert>
      </SectionIntro>
      <PreviewCanvas>
        <WidgetPreview view={widgetPreviewViews.full} appearance={appearance} />
      </PreviewCanvas>
    </Styles.Block>
  )
}

export default PreviewBlock
